
import { Options, Vue } from "vue-class-component"
import { Inject } from "vue-property-decorator"
import Collapse from "./collapse/index.vue"
import CollapseWrapper from "./collapse/wrapper.vue"

@Options({
  name: "setup-panel",
  props: ["modelValue", "collapse"],
  components: { Collapse, CollapseWrapper }
})
export default class Setup extends Vue {
  @Inject() config!: any

  showHandler(evt: any) {
    if (evt.target.classList.contains("setup-panel")) {
      this.config.setup.show = false
    }
  }
}
